module.exports = __webpack_public_path__ + "5fe1bfd676171e8a491b3968cb37fb96.jpg";